<div class="sidepanel-inner">
  <!-- Branding -->
  <div class="app-branding">
    <a (click)="onNavigate()" class="app-logo" routerLink="/administration/management/dashboard">
      <div class="logo-container">
        <div class="logo-icon-wrapper">
          <img alt="logo" class="logo-icon" src="images/app-logo.svg">
        </div>
        <div class="logo-text-wrapper">
          <span class="logo-text">Muslim Shoco</span>
          <span class="logo-subtitle">Administration</span>
        </div>
      </div>
    </a>
  </div>

  <!-- Navigation Material List -->
  <mat-nav-list class="app-nav">
    @for (menu of menus; track menu.link) {
      <a (click)="onNavigate()" [routerLink]="menu.link" mat-list-item routerLinkActive="active">
        <span matListItemTitle> {{ menu.label }} </span>
      </a>
    }

  </mat-nav-list>

</div>
